import {FormError} from "@/components/ui/forms/FormError";
import {
  clearForm,
  helpRequest,
  setAgree,
  setEmail,
  setError,
  setMessage,
  setName,
} from "@/redux/slices/commonSlices/requestSlice";

import {useEffect} from "react";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {SuccessSendPopup} from "@popups/attentionPopups/SuccessSendPopup";
import {RootButton} from "@ui/buttons/RootButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {Spinner} from "@ui/general/Spinner";
import {RootCheckbox} from "@ui/inputs/RootCheckbox";
import {RootInput} from "@ui/inputs/RootInput";
import {RootTextarea} from "@ui/inputs/RootTextarea";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation} from "react-router-dom";

import styles from "./styles.module.scss";

export const HelpPopup = () => {
  const {openPopup, closePopup} = usePopup();
  const userName = useSelector((state) => state.common.candidate.name);
  const userEmail = useSelector((state) => state.common.candidate.email);
  const {auth} = useSelector((state) => state.common.candidate);
  const {name, email, message, agree, error, status} = useSelector(
    (state) => state.common.request,
  );
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setError(""));

    if (auth) {
      if (!message || !userName || !userEmail) {
        dispatch(setError(t("server_error.fields")));
        return;
      }

      const resultAction = await dispatch(
        helpRequest({message, name: userName, email: userEmail}),
      );

      if (helpRequest.fulfilled.match(resultAction)) {
        dispatch(clearForm());
        openPopup(<SuccessSendPopup />);
      } else {
        dispatch(setError(t("server_error.submit_data")));
      }
    } else {
      if (!message || !name || !email) {
        dispatch(setError(t("server_error.fields")));
        return;
      }

      const resultAction = await dispatch(helpRequest({message, name, email}));

      if (helpRequest.fulfilled.match(resultAction)) {
        dispatch(clearForm());
        openPopup(<SuccessSendPopup />);
      } else {
        dispatch(setError(t("server_error.submit_data")));
      }
    }
  };

  useEffect(() => {
    dispatch(setError(""));
  }, [name, email, message, agree]);

  useEffect(() => {
    return () => {
      dispatch(clearForm());
    };
  }, []);

  return (
    <div className={styles.help}>
      <H3>{t("popup.help.title")}</H3>

      <RootDesc>
        <span>{t("popup.help.subtitle")}</span>
      </RootDesc>

      <form
        onSubmit={handleSubmit}
        className={styles.helpForm}
      >
        {location.pathname.includes("login") && (
          <>
            <div className={styles.input}>
              <RootInput
                width={500}
                label={t("input.name")}
                type={"text"}
                value={name}
                required
                onChange={(e) => dispatch(setName(e.target.value))}
                disabled={status === "loading" && true}
              />
            </div>

            <div className={styles.input}>
              <RootInput
                width={500}
                label={"Email"}
                type={"email"}
                value={email}
                required
                onChange={(e) => dispatch(setEmail(e.target.value))}
                disabled={status === "loading" && true}
              />
            </div>
          </>
        )}

        <div className={styles.input}>
          <RootTextarea
            label={t("input.problem")}
            type={"text"}
            value={message}
            required
            onChange={(e) => dispatch(setMessage(e.target.value))}
            disabled={status === "loading" && true}
          />
        </div>

        {location.pathname.includes("login") ? (
          <>
            <div className={styles.helpCheckbox}>
              <RootCheckbox
                fontSize={14}
                checked={agree}
                onChange={(e) => dispatch(setAgree(e.target.checked))}
                label={
                  <>
                    {t("input.privacy_checkbox_label")}{" "}
                    <Link
                      onClick={() => closePopup()}
                      to={"/privacy"}
                    >
                      {t("input.privacy_checkbox_link")}
                    </Link>
                  </>
                }
              />
            </div>

            <RootButton
              txt={t("button.submit")}
              type={"submit"}
              disabled={
                !message || !email || !name || !agree || status === "loading"
              }
            />
          </>
        ) : (
          <RootButton
            txt={"Submit"}
            type={"submit"}
            disabled={!message || status === "loading"}
          />
        )}

        {error !== "" && (
          <FormError
            error={error}
            bottom={105}
          />
        )}

        {status === "loading" && (
          <Spinner
            width={50}
            height={50}
          />
        )}
      </form>
    </div>
  );
};
